import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import LibraryApiCall from 'LibraryApiCall';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from 'react-select';
import ReactToPrint from 'react-to-print';

let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];

class DepartmentWiseSummaryReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All Periodical list
            departmentSummaryLoading: false,
            departmentSummaryData: {},
            grandTotalTitleCount: '',
            grandTotalTitlePrice: '',
            grandTotalTitleNoOfCopies: '',

            // report filter
            searchByResourceType: '',

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Department Name", isVisible: true },
                { name: "Total Title", isVisible: true },
                { name: "Total Price", isVisible: true },
                { name: "Total Copies", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Department Name", key: 'title' },
                { name: "Total Title", key: 'issnNumber' },
                { name: "Total Price", key: 'category' },
                { name: "Total Copies", key: 'noOfCopies' },
            ],

            exportItemVisibility: [
                { name: "Department Name", isVisible: true },
                { name: "Total Title", isVisible: true },
                { name: "Total Price", isVisible: true },
                { name: "Total Copies", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],
        };
    }

    componentDidMount() {
        this.getDepartmentWiseSummaryList();  // report list
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF REPORT
    getDepartmentWiseSummaryList = async () => {
        this.setState({
            departmentSummaryLoading: true
        });

        let requestData = {
            'iid': config.institute_id,
            'resourceType': this.state.searchByResourceType.value
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'libraryGetDepartmentWiseSummaryReport',
            requestData,
            '/api/library/libraryReports.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getDepartmentWiseSummaryList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {

                        this.setState({
                            departmentSummaryData: apiResult.data,
                            grandTotalTitleCount: apiResult?.grandTotalTitleCount,
                            grandTotalTitlePrice: apiResult?.grandTotalTitlePrice,
                            grandTotalTitleNoOfCopies: apiResult?.grandTotalTitleNoOfCopies,
                            departmentSummaryLoading: false
                        });
                    } else {
                        this.setState({
                            departmentSummaryData: {},
                            totalPeriodicalListItems: 0,
                            departmentSummaryLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        departmentSummaryData: {},
                        totalPeriodicalListItems: 0,
                        departmentSummaryLoading: false
                    });
                }
            }
        }
    }

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByResourceType: ''
        }, () => {
            this.getDepartmentWiseSummaryList();
        }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStatus = this.state.searchByResourceType.value


        if (filterStatus) {
            FilterArray.push(`Resource Type - ${filterStatus}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllPeriodicalReportList" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                Department-Wise Summary Report
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="4" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Department Name</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Total Title</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Total Price</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Total Copies</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="4">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((data, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{data?.departmentName || "-"}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{data?.titleTotal || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{data?.priceTotal || 0}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{data?.copiesTotal || 0}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="4">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { allReportData } = this.state;

        // Set the flag to indicate fetching of data
        this.setState({
            isExportAllReportDataFetching: true
        });

        // Request data
        let requestData = {
            'iid': config.institute_id,
            'resourceType': this.state.searchByResourceType
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'libraryGetDepartmentWiseSummaryReport',
            requestData,
            '/api/library/libraryReports.php'
        );

        // Check if the session has expired and retry if necessary
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.methodToExportReportData(); // Retry fetching
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Concatenate new data to the allReportData state
                this.setState({
                    allReportData: { ...allReportData, ...apiResult },
                    grandTotalTitleCount: apiResult?.grandTotalTitleCount,
                    grandTotalTitlePrice: apiResult?.grandTotalTitlePrice,
                    grandTotalTitleNoOfCopies: apiResult?.grandTotalTitleNoOfCopies,
                }, () => {
                    // Proceed to export all report data after fetching is complete
                    this.exportAllReportCSV();
                });
            } else {
                // Handle errors
                this.setState({
                    isExportAllReportDataFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                });
            }
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterStatus = this.state.searchByResourceType.value

        if (filterStatus) {
            FilterArray.push(`Resource Type - ${filterStatus}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Search By Resource Type*/}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Resource Type</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    name="resourceTypeFilter"
                                                                    options={resourceTypeData.map((item) => ({
                                                                        label: item,
                                                                        value: item
                                                                    }))}
                                                                    value={this.state.searchByResourceType}
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByResourceType: event || [], // Handle empty selection
                                                                        }, () => {
                                                                            this.getDepartmentWiseSummaryList()
                                                                        })
                                                                    }}
                                                                    isClearable
                                                                    placeholder="Select Resource Type"
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically,
                                                                            fontSize: "13px",
                                                                            fontWeight: 400,
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: "13px",
                                                                            fontWeight: 400,
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Select "Resource Type" to get Department-Wise Summary Report filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        {Object.keys(this.state.departmentSummaryData).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="periodicalReportList"
                                                                    filename="DepartmentWiseSummaryReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            {/* <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllPeriodicalReportList"   // export all functionality
                                                                    filename="ExportAllPeriodicalReportList"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div> */}
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {/* {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )} */}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByResourceType !== '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Department-Wise Summary Report</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="periodicalReportList">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        Department-Wise Summary Report
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="4" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Department Name</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Total Title</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Total Price</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Total Copies</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.departmentSummaryLoading ?
                                                    <tr>
                                                        <td colSpan="4">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    this.state.departmentSummaryData.length > 0 > 0 ?
                                                        this.state.departmentSummaryData.map((data, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{data?.departmentName || "-"}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{data?.titleTotal || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{data?.priceTotal || 0}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{data?.copiesTotal || 0}</td>}
                                                                </tr>
                                                            )
                                                        }) :
                                                        <tr>
                                                            <td colSpan="4">
                                                                No data found.
                                                            </td>
                                                        </tr>
                                            }
                                            {
                                                Object.keys(this.state.departmentSummaryData).length > 0 && !this.state.departmentSummaryLoading &&
                                                (() => {
                                                    const visibilities = this.state.exportItemVisibilityForRows;

                                                    return (
                                                        <>
                                                            {/* Grand Total Row */}
                                                            <tr>
                                                                <td style={{ textAlign: "right", fontWeight: "bold" }}>Grand Total</td>
                                                                {visibilities.map((col, idx) => {
                                                                    if (!col.isVisible) return null;

                                                                    if (idx === 1) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.grandTotalTitleCount}</td>;
                                                                    } else if (idx === 2) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.grandTotalTitlePrice}</td>;
                                                                    } else if (idx === 3) {
                                                                        return <td key={idx} style={{ textAlign: "right", fontWeight: "bold" }}>{this.state.grandTotalTitleNoOfCopies}</td>;
                                                                    } else {
                                                                        return <td key={idx}></td>;
                                                                    }
                                                                })}
                                                            </tr>
                                                        </>
                                                    );
                                                })()
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div >
                </div>
            </div >

        );
    }
}


export default DepartmentWiseSummaryReport;